export default __webpack_public_path__ + "static/summer_containers52-53fe803459b16e9c91f27ff5622f2443.webp";